import { formatISO } from 'date-fns'
import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { BlockResponse } from '@opallabs/api'
import { richTextDocumentResourceFactory as v3RichTextDocumentResourceFactory } from '../../v3/resource_objects/rich_text_document'
import { categoryTypeFactory } from '../components/category_type'
import { relatedBoardFactory } from '../components/related_board'
import { shallowCategoryFactory } from '../components/shallow_category'
import { planFactory } from './plan'

export const parentBlockFactory: Factory<BlockResponse> =
  Factory.define<BlockResponse>(({ sequence }) => {
    return {
      data: {
        boards: [relatedBoardFactory.build()],
        details: {
          category: shallowCategoryFactory.build(),
          category_type: categoryTypeFactory.build(),
          color: null,
          custom_fields: [],
          custom_field_values: [],
          inherited_custom_field_values: [],
          in_support_of_category_type_ids: [],
          description: null,
          image_id: null,
          last_updated_date: new Date().toISOString(),
          connectors: [],
        },
        duration: 'P14D',
        effective_privacy: 'some_but_not_all',
        id: uuidV4(),
        is_private: true,
        is_template: false,
        is_workspace_wide_template: false,
        child_plan_id: uuidV4(),
        owner_id: uuidV4(),
        paired_moment_id: null,
        title: `Mock Block ${sequence}`,
        template_description: null,
        template_name: null,
        rich_text_document_id: v3RichTextDocumentResourceFactory.build().id,
        start_date: formatISO(new Date()),
        view_id: planFactory.build().data.id,
      },
    } satisfies BlockResponse
  })
